/* unplugin-vue-components disabled */import { render } from "./LogicalTransformerSectorRender.vue?vue&type=template&id=20de309b&scoped=true"
import script from "./LogicalTransformerSectorRender.vue?vue&type=script&lang=js"
export * from "./LogicalTransformerSectorRender.vue?vue&type=script&lang=js"

import "./LogicalTransformerSectorRender.vue?vue&type=style&index=0&id=20de309b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20de309b"]])

export default __exports__